import { configureStore } from '@reduxjs/toolkit';
import languageReducer from './slices/languageSlice';
import authReducer from './slices/authSlice';
import searchReducer from './slices/searchSlice';
import aiSearchReducer from './slices/aiSearchSlice';
import locationSlice from './slices/locationSlice';
import notificationsReducer from './slices/notificationsSlice';
import errorSlice from './slices/errorSlice';
import favoritesSlice from './slices/favoritesSlice';
import messagesSlice from './slices/messagesSlice'
import blocksReducer from './slices/blocksSlice';

export const store = configureStore({
  reducer: {
    language: languageReducer,
    auth: authReducer,
    search: searchReducer,
    aiSearch: aiSearchReducer,
    location: locationSlice,
    notifications: notificationsReducer,
    errors: errorSlice,
    favorites: favoritesSlice,
    messages: messagesSlice,
    blocks: blocksReducer,
  },
});
